<template>
	<div class="bg">
    <div class="model">
      <div class="title">{{data.title}}</div>
      <svgIcon :iconClass="data.svg" class="msg" v-if="data.svg"/>
      <div>{{data.name}}</div>
    </div>
  </div>
</template>

<script>
import svgIcon from './plugins/svgIcon.vue'
	export default {
  components: { svgIcon },
		name: 'Msg',
		props: ['data'],
		data() {
			return{
				
			}
		},
		
		created() {
		},
		mounted() {
			
		},
		methods:{
		
		}
	}
</script>
<style scoped>
@media screen and (min-width:360px) and (max-width:820px) {
   .model .msg{
    width: 25px;
    height: 25px;
    color: #F7AB00;
    margin-right: 10px;
  }
  .model .title{
    font-size: 90px;
    height: 120px;
    line-height: 120px;
  }
  .model{
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 1200px;
    height: 600px;
    text-align: center;
    background: #000000b8;
    /* box-shadow: 0px 5px 15px 0px #ddd; */
    display: flex;
    align-items: center;
    flex-direction:column;
    font-size: 68px;
    padding: 40px;
    border-radius: 40px;
    overflow: hidden;
    color: #fff;
  }
  .model div{
    margin: 40px 0;
    line-height: 80px;
  }
}
@media screen and (min-width:821px) and (max-width:4000px) {
	 .model .msg{
    width: 25px;
    height: 25px;
    color: #F7AB00;
    margin-right: 10px;
  }
  .model .title{
    font-size: 20px;
    height: 40px;
    line-height: 40px;
  }
  .model{
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 240px;
    height: 120px;
    text-align: center;
    background: #000000b8;
    /* box-shadow: 0px 5px 15px 0px #ddd; */
    display: flex;
    align-items: center;
    flex-direction:column;
    font-size: 14px;
    padding: 10px;
    border-radius: 10px;
    overflow: hidden;
    color: #fff;
  }
  .model div{
    margin: 10px 0;
    line-height: 20px;
  }
  }
</style>
